import store from '../store'
import { isEmpty } from '@/common/utils'

const KEY = 'channel'

/**
 * load channel
 * @returns {Promise<String>}
 */
const loadChannel = async () => {
  let value = await store.get(KEY)

  if (isEmpty(value)) {
    value = process.env.VUE_APP_CHANNEL

    await storeChannel(value)
  }

  return value
}

/**
 * store channel
 * @param {String} value
 *
 * @returns {Promise<String>}
 */
const storeChannel = value => {
  return store.set(KEY, value)
}

export { loadChannel, storeChannel }
